import React from 'react';
import type { BookingPurchaseDialogData } from '../BookingPurchaseDialog.types';
import { DialogFooter } from '../footer/DialogFooter';

type Props = {
  data: BookingPurchaseDialogData;
};

function ResponseSubtitle({ subtitle }: { subtitle?: string }) {
  if (!subtitle) {
    return null;
  }

  return <p className="content-group-subtitle">{subtitle}</p>;
}

function ResponseErrors({ errors }: { errors: string[] }) {
  return (
    <>
      {errors.map((error, index) => (
        <span key={`error-${index}`}>
          <br />
          {error}
        </span>
      ))}
    </>
  );
}

export function ResponseView({
  data,
  iconClass,
  headingId,
}: Props & {
  iconClass: string;
  headingId?: string;
}) {
  return (
    <div className="modal-body modal-bookbuy-response">
      <div className="row">
        <div className="col s12">
          <div className="content-group">
            <div className={iconClass} />
          </div>
          <div className="content-group">
            {data.responseTitle ? (
              <h4 id={headingId}>{data.responseTitle}</h4>
            ) : null}
            {data.responseName ? <h3>{data.responseName}</h3> : null}
            <ResponseErrors errors={data.responseErrors || []} />
            <ResponseSubtitle subtitle={data.responseSubtitle} />
          </div>
          <DialogFooter footerButtons={data.footerButtons} />
        </div>
      </div>
    </div>
  );
}

export function ScaPendingView({ data }: Props) {
  return (
    <div className="modal-body modal-bookbuy-response">
      <div className="row">
        <div className="col s12">
          <div className="content-group">
            <div>
              <img src="images/warning-triangle.svg" alt="warning" />
            </div>
          </div>
          <div className="content-group">
            {data.responseTitle ? (
              <h3 id="sca-verification-heading">{data.responseTitle}</h3>
            ) : null}
            <ResponseSubtitle subtitle={data.responseSubtitle} />
          </div>
          <DialogFooter footerButtons={data.footerButtons} />
        </div>
      </div>
    </div>
  );
}
